import { AxiosInstance } from "axios"

export interface AgentBooking {
  booking_id: number
  booking_number: string
  booking_init_date: number
  agent_booking_status: string
  status_id: number
  agent_id: number
  agent_share_link_id: number | null
  guest_user_id: number
  guest_name: string
  guest_full_name: string
  guest_email: string
  guest_mobile: string
  property_id: string
  property_name: string
  property_full_address: string
  property_image_name: string
  image_url: string
  check_in_date: number
  check_out_date: number
  traveler_payment_amount: number
  traveler_charge_amount: number
  commission_id: number | null
  commission_amount: number | null
  commission_rate: number | null
  commission_status: string | null
  uplift_rate_amount: number | null
  invoice_url: string | null
  client_receipt_full_price: string | null
  client_receipt_no_price: string | null
  agent_receipt_with_commission: string | null
  staged_payment: boolean
  adult_number: number | null
}

export interface GetAgentBookingsRequest {
  page: number
  size: number
  status?: string
  keyword?: string
  filterAgentId?: number
  csv?: boolean
}

export interface GetAgentBookingsResponse {
  time: string
  apiStatus: string
  data: {
    content: AgentBooking[]
    totalElements: number
    totalPages: number
    number: number
    size: number
    first: boolean
    last: boolean
  }
}

export function getAgentBookingsApi(
  params: GetAgentBookingsRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: "/agent/bookings",
    params,
    responseType: params.csv ? "blob" : "json",
  }) as Promise<{ data: GetAgentBookingsResponse }>
}
